import React from 'react';
import { services } from '../data/siteData';
function Services() {
return (
<section className="section bg-light" id="services">
<div className="container">
<div className="section-header">
<p className="section-subtitle">Our Services</p>
<h2 className="section-title">What We Build For Modern Businesses</h2>
<p className="section-text center-text">
We create digital solutions that improve operations, user
experience,
and long-term business performance.
</p>
</div>
<div className="card-grid">
{services.map((service, index) => {
const Icon = service.icon;
return (
<div className="info-card" key={index}>
<div className="icon-wrap">
<Icon />
</div>
<h3>{service.title}</h3>
<p>{service.description}</p>
</div>
);
})}
</div>
</div>
</section>
);
}
export default Services;